import horseApi from 'apis/horseApi'
import { links } from 'apps'
import { CLOSE_BTN, ICON_BORROW, LEVEL_UP, NEW_RECORD, VIEW_DOPING } from 'assets/images'
import { EnergyBar } from 'features/Horse/components'
import { useAppDispatch, useToggle } from 'hooks'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { ApiResponse, Horse, LENDING_STATUS } from 'models'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ClassTag, Modal } from 'shared'
import { getGuildTag, handleAsyncRequest, hanldeHorseOwnerName } from 'utils/helper'
import HorseBodyInfo from '../HorseBodyInfo'
import VipIcon from 'features/components/VipIcon'
import HorseAvatar from 'features/Horse/components/HorseItem/HorseAvatar'
import MemoizedLoadImageCommon from 'shared/MemoizedImage/LoadImageCommon'
import HorseModalRaceViewStyled from './styled'
import { getImageGender, getImageRegion } from 'utils/getLinkImage'
import { updateStateModal } from 'features/Profile/profile.slice'

interface HorseModalRaceViewProps {
  horseId: number
  onCloseButtonClick?: () => void
  myName: string | number
  atProfile: boolean
  raceId: string
  currentHolder?: boolean
}

function HorseModalRaceView({
  horseId,
  onCloseButtonClick,
  myName,
  atProfile,
  raceId,
  currentHolder = false
}: HorseModalRaceViewProps) {
  const [horse, setHorse] = useState<Horse>()
  const [isLoading, setIsLoading] = useToggle(false)
  const [firstTime, setFirstTime] = useState(0)
  const { t } = useTranslation()
  const isHorseVip = horse?.msp_details?.msp;
  const dispatch = useAppDispatch()
  
  useEffect(() => {
    if (!currentHolder) {
      const fetchHorse = async () => {
        setIsLoading(true)
  
        const [, horseResponse] = await handleAsyncRequest<ApiResponse<Horse>>(
          horseApi.getHorseDetailRaceView(String(horseId), raceId)
        )
  
        if (horseResponse) {
          const fetchedHorse = horseResponse.data
          setHorse(fetchedHorse)
        }
  
        setIsLoading(false)
      }
  
      fetchHorse()
    } else {
      const fetchHorse = async () => {
        setIsLoading(true)
  
        const [, horseResponse] = await handleAsyncRequest<ApiResponse<Horse>>(
          horseApi.getHorseDetailByTokenId({ horse_id: horseId })
        )
  
        if (horseResponse) {
          const fetchedHorse = horseResponse.data
          setHorse(fetchedHorse)
        }
  
        setIsLoading(false)
      }
  
      fetchHorse()
    }
  }, [horseId])

  // get time when access first room horse
  useEffect(() => {
    if (horse && horse?.remaining_time_to_next_energy > 0) {
      const start_at = horse?.remaining_time_to_next_energy
      setFirstTime(start_at)
    }
  }, [horse])

  const checkHorseOwner = () => {
    if (!horse?.owner) {
      if (horse?.user?.id === myName || horse?.user?.name === myName) return true
    }
    if (horse?.owner?.id === myName || horse?.owner?.name === myName) return true
    else return false
  }

  const showModalUserInfo = () => {
    if (horse?.user?.id) {
      dispatch(updateStateModal({
        isOpen: true,
        userId: horse?.user?.id
      }))
    }
  }

  // time waiting
  return (
    <Modal onOverlayClick={onCloseButtonClick}>
      <HorseModalRaceViewStyled>
        {horse && !isLoading && (
          <Fragment>
            <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
              <img src={CLOSE_BTN} alt='close' />
            </button>
            <div className='quick-view'>
              <div className='container'>
                <div className='quick-view-box position-relative'>
                  <div className='quick-view-container d-flex flex-column flex-lg-row align-items-lg-center'>
                    <div className='quick-view-left'>
                      <div className='left'>
                        <div className='name color-white font-bold d-block d-lg-none mb-4'>
                          {horse.name}
                        </div>
                        <HorseAvatar
                          horse={horse}
                          name={horse?.name}
                          avatar={horse?.avatar}
                          items={horse?.weapon_items_equipped}
                        />
                        <div className='energy-container'>
                          {horse?.user?.name === myName || horse?.user?.id === myName ? (
                            <EnergyBar
                              maxEnergy={horse.max_energy}
                              currentEnergy={horse.current_energy}
                              customClass='custom-energy mx-auto'
                              firstTime={firstTime}
                              disableRecovery={false}
                            // isShowPlusIcon
                            />
                          ) : (
                            ''
                          )}
                        </div>
                        {atProfile && (
                          <div className='d-flex justify-content-center'>
                            <div className='detail-btn-container align-items-center mt-4'>
                              <a
                                rel='noopener noreferrer'
                                href={atProfile ? links.horse.detail(horseId) : links.horse.detail(horseId)}
                                target='_blank'
                              >
                                <button className='detail-btn font-bold w-100 h-100'>
                                  <span className='color-primary'>{t(`${NOTIFICATION_MESSAGE}.details`)}</span>
                                </button>
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='quick-view-right'>
                      <div className='right'>
                        <div className='d-flex right-title'>
                          <div className='title'>
                            <div className='name color-white d-flex align-items-center'>
                              <div><span className='color-yellow'>{horse.guild && `[${horse.guild?.guild_tag}]`}</span> {horse?.name}</div>

                              <div className='icon-gender'>
                                <MemoizedLoadImageCommon srcImg={getImageGender(horse?.gender)} />
                              </div>

                              <div className='region'>
                                <MemoizedLoadImageCommon srcImg={getImageRegion(horse?.region)} />
                              </div>

                              <ClassTag text={horse?.racing_class ?? ''} isActive={true} customClass='ms-3' />
                              {checkHorseOwner() ? (  
                                <div className={`level-up ms-3 ${horse.level.level.toString().length > 1 ? 'horse-level' : ''}`}>
                                  <img src={LEVEL_UP} alt='' width={50} />
                                  <span className='color-white text-uppercase'>{horse?.level?.level}</span>
                                </div>
                              ) : (
                                ''
                              )}

                              {
                                ((horse.own_status === LENDING_STATUS.Lending || horse.own_status === LENDING_STATUS.IN_GUILD) && horse.user) ?
                                  <div className='icon-borrow ms-2'>
                                    <img src={ICON_BORROW} alt='' width={55} />
                                  </div> : ''
                              }

                              {isHorseVip && (
                                <div className='vip-icon'>
                                  <VipIcon />
                                </div>
                              )}
                              
                              {horse.equipped_boost_item && (
                                <div className='contain__dopping'>
                                  <MemoizedLoadImageCommon srcImg={VIEW_DOPING} alt="" />
                                </div>
                              )}

                              {/* new record */}
                              {horse.is_new_record && <div className='img_new_record'>
                                <MemoizedLoadImageCommon srcImg={NEW_RECORD} />
                              </div>}
                            </div>
                            <div className='name-user color-white text-uppercase'>
                              {t(`${NOTIFICATION_MESSAGE}.owner`)}: <span className='color-yellow'>{horse?.user && getGuildTag(horse?.user?.guild_tag)}</span> <span className='cursor-pointer' onClick={showModalUserInfo}> {hanldeHorseOwnerName(horse)}</span>
                            </div>
                          </div>
                        </div>
                        <HorseBodyInfo horse={horse} customClass="custom-bottom-frame" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </HorseModalRaceViewStyled>
    </Modal>
  )
}

export default HorseModalRaceView
